module.exports = __webpack_public_path__ + "static/media/peach.642a0a7f.jpg";